import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import RegisterForm from "./Form";
import RegisterComplete from "./RegisterComplete";

const Register = () => {
  const { pathname } = useLocation();

  const completeMatch = pathname.match(/^\/register\/complete\/([^/]+)$/);

  if (pathname === "/register") {
    return <RegisterForm />;
  }

  if (completeMatch) {
    const token = completeMatch[1];
    return (
      <Fragment>
        <h1 className="d-flex justify-content-center align-items-center">
          Completa tu registro
        </h1>
        <RegisterComplete token={token} />
      </Fragment>
    );
  }
};

export default Register;
